import React, { useEffect } from 'react';

const FormView = () => {
    const [formData, setFormData] = React.useState(null);
    const [formValues, setFormValues] = React.useState({});
    const [errors, setErrors] = React.useState({});
    const [loading, setLoading] = React.useState(false);
    const [otpSent, setOtpSent] = React.useState({});
    const [otpValues, setOtpValues] = React.useState({});

    useEffect(() => {
        const savedFormData = localStorage.getItem('formData');
        if (savedFormData) {
            try {
                const parsedFormData = JSON.parse(savedFormData);
                console.log('Loaded Form Data:', parsedFormData);

                // Handle both array and object structure
                const fieldsArray = Array.isArray(parsedFormData)
                    ? parsedFormData
                    : (parsedFormData.fields ? parsedFormData.fields : []);

                setFormData(fieldsArray);

                // Initialize form values
                const initialValues = {};
                fieldsArray.forEach(field => {
                    initialValues[field.name] = '';
                });
                setFormValues(initialValues);
            } catch (error) {
                console.error('Error parsing form data:', error);
                setFormData([]);
            }
        }
    }, []);
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormValues(prev => ({
            ...prev,
            [name]: value
        }));
        // Clear error for this field when user starts typing
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };

    const validateForm = () => {
        const newErrors = {};
        formData.forEach(field => {
            if (field.type === 'iagree') {
                if (field.required && !formValues[field.name]) {
                    newErrors[field.name] = `${field.label} is required`;
                }
            } else if (field.required && !formValues[field.name]) {
                newErrors[field.name] = `${field.label} is required`;
            }
            if (field.type === 'email' && formValues[field.name]) {
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailRegex.test(formValues[field.name])) {
                    newErrors[field.name] = 'Please enter a valid email';
                }
            }
            if ((field.type === 'numberwithotp' || field.type === 'phone' || field.type === 'whatsapp') && formValues[field.name]) {
                const phoneRegex = /^[0-9]{10}$/;
                if (!phoneRegex.test(String(formValues[field.name]).replace(/[^0-9]/g, ''))) {
                    newErrors[field.name] = 'Please enter a valid 10-digit mobile number';
                }
            }
        });
        return newErrors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const newErrors = validateForm();

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        setLoading(true);
        try {
            console.log('Form Values Submitted:', formValues);

            // Replace with your actual API endpoint
            const response = await fetch('/api/forms/submit', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formValues)
            });

            if (response.ok) {
                console.log('Form submitted successfully!');
                alert('Form submitted successfully!');
                // Reset form
                const initialValues = {};
                formData.forEach(field => {
                    initialValues[field.name] = '';
                });
                setFormValues(initialValues);
            } else {
                alert('Error submitting form');
            }
        } catch (error) {
            console.error('Error:', error);
            alert('Error submitting form');
        } finally {
            setLoading(false);
        }
    };

    const renderField = (field) => {
        const fieldError = errors[field.name];
        const baseClasses = `form-control ${fieldError ? 'is-invalid' : ''}`;

        switch (field.type) {
            case 'text':
            case 'singleline':
                return (
                    <input
                        type="text"
                        className={baseClasses}
                        name={field.name}
                        placeholder={field.placeholder}
                        value={formValues[field.name] || ''}
                        onChange={handleInputChange}
                        required={field.required}
                    />
                );
            case 'email':
                return (
                    <input
                        type="email"
                        className={baseClasses}
                        name={field.name}
                        placeholder={field.placeholder}
                        value={formValues[field.name] || ''}
                        onChange={handleInputChange}
                        required={field.required}
                    />
                );
            case 'number':
                return (
                    <input
                        type="number"
                        className={baseClasses}
                        name={field.name}
                        placeholder={field.placeholder}
                        value={formValues[field.name] || ''}
                        onChange={handleInputChange}
                        required={field.required}
                    />
                );
            case 'phone':
                return (
                    <input
                        type="tel"
                        className={baseClasses}
                        name={field.name}
                        placeholder={field.placeholder || 'Enter phone number'}
                        value={formValues[field.name] || ''}
                        onChange={handleInputChange}
                        required={field.required}
                    />
                );
            case 'whatsapp':
                return (
                    <input
                        type="tel"
                        className={baseClasses}
                        name={field.name}
                        placeholder={field.placeholder || 'Enter WhatsApp number'}
                        value={formValues[field.name] || ''}
                        onChange={handleInputChange}
                        required={field.required}
                    />
                );
            case 'url':
                return (
                    <input
                        type="url"
                        className={baseClasses}
                        name={field.name}
                        placeholder={field.placeholder}
                        value={formValues[field.name] || ''}
                        onChange={handleInputChange}
                        required={field.required}
                    />
                );
            case 'date':
                return (
                    <input
                        type="date"
                        className={baseClasses}
                        name={field.name}
                        value={formValues[field.name] || ''}
                        onChange={handleInputChange}
                        required={field.required}
                    />
                );
            case 'time':
                return (
                    <input
                        type="time"
                        className={baseClasses}
                        name={field.name}
                        value={formValues[field.name] || ''}
                        onChange={handleInputChange}
                        required={field.required}
                    />
                );
            case 'textarea':
                return (
                    <textarea
                        className={baseClasses}
                        name={field.name}
                        placeholder={field.placeholder}
                        value={formValues[field.name] || ''}
                        onChange={handleInputChange}
                        required={field.required}
                        rows="4"
                    />
                );
            case 'select':
                return (
                    <select
                        className={baseClasses}
                        name={field.name}
                        value={formValues[field.name] || ''}
                        onChange={handleInputChange}
                        required={field.required}
                    >
                        <option value="">-- Select {field.label} --</option>
                        {field.options && field.options.map((option, idx) => (
                            <option key={idx} value={option}>
                                {option}
                            </option>
                        ))}
                    </select>
                );
            case 'radio':
                return (
                    <div>
                        {field.options && field.options.map((option, idx) => (
                            <div key={idx} className="form-check">
                                <input
                                    type="radio"
                                    className="form-check-input"
                                    id={`${field.name}_${idx}`}
                                    name={field.name}
                                    value={option}
                                    checked={formValues[field.name] === option}
                                    onChange={handleInputChange}
                                    required={field.required}
                                />
                                <label className="form-check-label" htmlFor={`${field.name}_${idx}`}>
                                    {option}
                                </label>
                            </div>
                        ))}
                    </div>
                );
            case 'multiplechoice':
                return (
                    <div>
                        {field.options && field.options.map((option, idx) => (
                            <div key={idx} className="form-check">
                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id={`${field.name}_${idx}`}
                                    name={field.name}
                                    value={option}
                                    checked={(formValues[field.name] || []).includes(option)}
                                    onChange={(e) => {
                                        const currentValues = formValues[field.name] || [];
                                        let updatedValues;
                                        if (e.target.checked) {
                                            updatedValues = [...currentValues, option];
                                        } else {
                                            updatedValues = currentValues.filter(v => v !== option);
                                        }
                                        setFormValues(prev => ({
                                            ...prev,
                                            [field.name]: updatedValues
                                        }));
                                        if (errors[field.name]) {
                                            setErrors(prev => ({
                                                ...prev,
                                                [field.name]: ''
                                            }));
                                        }
                                    }}
                                />
                                <label className="form-check-label" htmlFor={`${field.name}_${idx}`}>
                                    {option}
                                </label>
                            </div>
                        ))}
                    </div>
                );
            case 'numberwithotp':
                return (
                    <div>
                        <div className="input-group mb-2">
                            <input
                                type="number"
                                className={baseClasses}
                                name={field.name}
                                placeholder={field.placeholder}
                                value={formValues[field.name] || ''}
                                onChange={handleInputChange}
                                required={field.required}
                            />
                            <button
                                type="button"
                                className="btn btn-sm btn-primary"
                                onClick={() => {
                                    if (formValues[field.name]) {
                                        const phoneRegex = /^[0-9]{10}$/;
                                        if (!phoneRegex.test(formValues[field.name])) {
                                            alert('Please enter a valid 10-digit mobile number');
                                            console.log('Invalid phone number:', formValues[field.name]);
                                        } else {
                                            setOtpSent(prev => ({
                                                ...prev,
                                                [field.name]: true
                                            }));
                                            alert(`OTP sent to ${formValues[field.name]}`);
                                            console.log(`OTP verification sent for: ${formValues[field.name]}`);
                                        }
                                    } else {
                                        alert('Please enter a mobile number');
                                    }
                                }}
                            >
                                Send OTP
                            </button>
                        </div>
                        {otpSent[field.name] && (
                            <div className="input-group">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter OTP (4 digits)"
                                    value={otpValues[field.name] || ''}
                                    onChange={(e) => {
                                        setOtpValues(prev => ({
                                            ...prev,
                                            [field.name]: e.target.value
                                        }));
                                    }}
                                    maxLength="4"
                                />
                                <button
                                    type="button"
                                    className="btn btn-sm btn-success"
                                    onClick={() => {
                                        if (otpValues[field.name] && otpValues[field.name].length === 4) {
                                            console.log(`OTP Verified for ${field.name}: ${otpValues[field.name]}`);
                                            alert('OTP Verified Successfully!');
                                            setOtpSent(prev => ({
                                                ...prev,
                                                [field.name]: false
                                            }));
                                            setOtpValues(prev => ({
                                                ...prev,
                                                [field.name]: ''
                                            }));
                                        } else {
                                            alert('Please enter a valid 4-digit OTP');
                                        }
                                    }}
                                >
                                    Verify OTP
                                </button>
                            </div>
                        )}
                    </div>
                );
            case 'iagree':
                return (
                    <div className="form-check">
                        <input
                            type="checkbox"
                            className="form-check-input"
                            id={field.name}
                            name={field.name}
                            checked={formValues[field.name] || false}
                            onChange={(e) => {
                                setFormValues(prev => ({
                                    ...prev,
                                    [field.name]: e.target.checked
                                }));
                                if (errors[field.name]) {
                                    setErrors(prev => ({
                                        ...prev,
                                        [field.name]: ''
                                    }));
                                }
                            }}
                            required={field.required}
                        />
                        <label className="form-check-label" htmlFor={field.name}>
                            {field.label}
                            {field.required && <span className="text-danger">*</span>}
                        </label>
                    </div>
                );
            default:
                return null;
        }
    };

    if (!formData) {
        return <div className="alert alert-info">No form data found</div>;
    }

    return (
        <div className="wrapper">
            <div className="main">
                <main className="content">
                    <div className="container-fluid p-0">
                        <div className="">
                            <div
                                className="alert card alert-outline alert-dismissible"
                                role="alert"
                            >
                                <div className="card-body">
                                    <div className="row justify-content-center">
                                        <div className="col-md-8 text-center">
                                            <h5 className="m-0">
                                                Share Your Feedback
                                            </h5>
                                            <p>
                                                Share Your valuable feedback and help us improve by leaving a review on our marketplace page.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="card">
                                        <div className="card-body">
                                            <form onSubmit={handleSubmit}>
                                                <div className="row">
                                                    {formData.map(field => {
                                                        let colClass = 'col-md-12';
                                                        if (field.width === 'half') {
                                                            colClass = 'col-md-6';
                                                        } else if (field.width === 'third') {
                                                            colClass = 'col-md-4';
                                                        } else if (field.width === 'full') {
                                                            colClass = 'col-md-12';
                                                        }
                                                        return (
                                                            <div
                                                                key={field.id}
                                                                className={`${colClass} mb-3`}
                                                            >
                                                                <label className="form-label col-form-label">
                                                                    {field.label}
                                                                    {field.required && <span className="text-danger">*</span>}
                                                                </label>
                                                                {renderField(field)}
                                                                {field.helperText && (
                                                                    <small className="form-text">
                                                                        {field.helperText}
                                                                    </small>
                                                                )}
                                                                {errors[field.name] && (
                                                                    <div className="invalid-feedback" style={{ display: 'block' }}>
                                                                        {errors[field.name]}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                                <button
                                                    type="submit"
                                                    className="btn d-flex justify-content-end btn-sm btn-primary"
                                                    disabled={loading}
                                                >
                                                    {loading ? 'Submitting...' : 'Submit'}
                                                </button>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </div>
    );
};

export default FormView;